import { Icon } from "@iconify/react";
import React from "react";
import { useDispatch } from "react-redux";
import { deleteLookup } from "../../../redux/lookupSlice";

const LookUpsValueAdded = ({ types }) => {
  const dispatch = useDispatch();
  return (
    <ul className="valueAdded">
      {types &&
        types.map((type) => (
          <li key={type.id}>
            <span>{type.id}</span>
            <button
              className="btn remove"
              onClick={() => dispatch(deleteLookup(type.id))}
            >
              <Icon icon="iconoir:cancel" />
            </button>
          </li>
        ))}
    </ul>
  );
};

export default LookUpsValueAdded;
